import "./application-status.scss";
import { DownloadSvg } from "../../../../../assets/svg";
import { useSolicitorCaseDetailsContext } from "../../../../../context/solicitor-case-details-context";
import { ApplicationStatusEnum } from "../../../../../models/enum/application-status.enum";
import { SolicitorCaseStatusEnum } from "../../../../../models/enum/solicitor-case-status.enum";
import { useAppSelector } from "../../../../../redux/hook";
import { downloadFile } from "../../../../../utils/download-file";
import { getSolicitorCaseStatus } from "../../../../../utils/string-formatter";

interface ApplicationStatusProps {
  status: ApplicationStatusEnum;
}

function ApplicationStatus({ status }: ApplicationStatusProps) {
  // States
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const { solicitorCaseSummaryData } = useSolicitorCaseDetailsContext();

  const solicitorCaseStatus = getSolicitorCaseStatus(status, solicitorCaseSummaryData?.lodgement_date);

  if (solicitorCaseStatus === SolicitorCaseStatusEnum.ipa_received) {
    return (
      <button className="polymer-application-status__button" onClick={() => downloadFile(solicitorCaseSummaryData?.ipa_download_key ?? "", singpassToken)}>
        <span>IPA received</span>
        <DownloadSvg strokeColor={"#0A676D"} />
      </button>
    );
  }

  return <span className="polymer-application-status__text">{solicitorCaseStatus}</span>;
}

export { ApplicationStatus };
